<script>
    export let onPrev;
    export let onNext;
    export let hasPrev = false;
    export let hasNext = false;
</script>

<div class="nav-buttons">
    <button
        class="nav-btn btn btn-primary"
        on:click={onPrev}
        disabled={!hasPrev}
    >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        >
            <path d="M15 18l-6-6 6-6" />
        </svg>
        Précédent
    </button>
    <button
        class="nav-btn btn btn-primary"
        on:click={onNext}
        disabled={!hasNext}
    >
        Suivant
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        >
            <path d="M9 18l6-6-6-6" />
        </svg>
    </button>
</div>

<style>
    .nav-buttons {
        display: flex;
        gap: 1rem;
        justify-content: center;
    }

    .nav-btn {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        border: none;
        padding: 0.8rem 1.5rem;
        border-radius: 8px;
        font-size: 1rem;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s;
    }

    .nav-btn:hover:not(:disabled) {
    }

    .nav-btn:disabled {
        cursor: not-allowed;
    }

    @media (max-width: 640px) {
        .nav-buttons {
            flex-direction: column;
        }

        .nav-btn {
            width: 100%;
        }
    }
</style>
